module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_10.c56700db.png";